import clsx from 'clsx'
import { StackIcon } from 'shared/ui'

import css from './SortIcon.module.scss'

const SortIcon = (props: {
	idx: string
	isFiltering: string
	isRunning: boolean
	isSortedAsc: Record<string, boolean>
	setIsFiltering: any
	setIsSortedAsc: any
	sort: string
	text: string
}) => {
	const {
		idx,
		isFiltering = '',
		isRunning,
		isSortedAsc,
		setIsFiltering,
		setIsSortedAsc,
		sort,
		text
	} = props
	const isActive = isFiltering.includes(sort)
	const getSortType = (idx: string, type: 'asc' | 'desc', running: string) => {
		switch (idx) {
			case 'contact':
				return isRunning ? `${running}full_name ${type}` : `full_name ${type}`
			case 'contacted':
				return isRunning ? `${running}contacted ${type}` : `contacted ${type}`
			case 'created':
				return `created ${type}, id ${type}`
			case 'custom_field_1':
				return isRunning
					? `${running}custom_field_1 ${type}`
					: `custom_field_1 ${type}`
			case 'custom_field_2':
				return isRunning
					? `${running}custom_field_2 ${type}`
					: `custom_field_2 ${type}`
			case 'custom_field_3':
				return isRunning
					? `${running}custom_field_3 ${type}`
					: `custom_field_3 ${type}`
			case 'headline':
				return isRunning
					? `${running}occupation ${type} `
					: `occupation ${type}`

			case 'imported':
				return `imported ${type}`
			case 'location':
				return isRunning ? `${running}location ${type} ` : `location ${type}`
			case 'status':
				return `state ${type} `
			default:
				return `imported ${type}`
		}
	}

	const isAscend = isSortedAsc[idx]
	const willBeAsc = !isAscend || !isActive

	return (
		<div
			className={clsx(
				'container-icon-sort',
				{
					active: isActive
				},
				isActive ? 'main-title-active' : 'main-title'
			)}
			onClick={() => {
				setIsSortedAsc(idx, willBeAsc)
				setIsFiltering(
					`${getSortType(idx, willBeAsc ? 'asc' : 'desc', 'linkedin_contact/')}`
				)
			}}
		>
			<p className={isActive ? 'main-title-active' : 'main-title'}>{text}</p>
			<StackIcon
				className={clsx(css.icon, !isAscend && css.desc)}
				icon='ascend'
				width={18}
			/>
		</div>
	)
}

export default SortIcon
